import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { FilterFieldValue } from '../../../covance-filter';
import { AdminActivityReportsFilterResolver } from '../../activity-reports/documents/admin-activity-reports-filter-resolver';

@Injectable()
export class AdminEquerySummaryFiltersGuard implements CanActivate {

    constructor(
        private readonly router: Router,
        private readonly filtersResolver: AdminActivityReportsFilterResolver,
    ) { }

    public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const filters = this.filtersResolver.resolveFilters('equery-summary');
        if (!this.checkFilterParamsAreSet(filters, route)) {
            this.setDefaultFilter(route, state);
            return false;
        }

        return true;
    }

    private checkFilterParamsAreSet(filters: FilterFieldValue[], route: ActivatedRouteSnapshot) {
        return filters.length === 0 || filters.filter(f => f.def.isServerSideFilter).some(f => route.queryParams[f.def.queryParam]);
    }

    private setDefaultFilter(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const defaultAgeRange = 'LessThen7';
        const defaultStatus = '["4"]';
        this.router.navigate([state.url], {
            queryParams: { age: `${defaultAgeRange}`, status: `${defaultStatus}` }
        });
    }
}